"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
ReorderableModuleListNavCtrl.$inject = ["$scope", "eventService", "localStorageService", "metricsService"];
BlueprintCurrentModuleNavCtrl.$inject = ["$window", "$route", "$location", "$rootScope", "$scope", "uiService", "orgService", "userService", "deeplinkService", "blueprintService", "entitlementsService", "urlService"];
MainEventContextNavCtrl.$inject = ["$rootScope", "$scope", "uiService", "blueprintService", "userService"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _require = require('underscore'),
  findWhere = _require.findWhere;

/* @ngInject */
function MainEventContextNavCtrl($rootScope, $scope, uiService, blueprintService, userService) {
  var lastSelectedEvent = null;
  $scope.$on('$routeChangeSuccess', function () {
    $scope.navDescriptors = blueprintService.getNavHeadings('event');
  });

  // captured by directives#collapseOnEventChangeRequested
  $scope.selectEvent = function (event) {
    if (!event) {
      event = {};
    }
    $scope.$emit('eventChangeRequested');
    return lastSelectedEvent = event;
  };
  $scope.shouldShowNavItem = uiService.shouldShowNavItem;
  $rootScope.$watch('user', function (currentUser, oldUser) {
    if (currentUser && currentUser._id !== (oldUser || {})._id) {
      if (userService.matchesRoles([{
        globalRole: 'superadmin'
      }, {
        eventRole: 'manager'
      }, {
        eventRole: 'editor'
      }])) {
        return $scope.canAccessMarketplace = true;
      }
    }
    $scope.canAccessMarketplace = false;
  });

  // emitted by directives#collapseOnEventChangeRequested
  return $scope.$on('eventChangeContinue', function () {
    if (!lastSelectedEvent) {
      return;
    }
    return $scope.navigateHard($rootScope.getGeoOptimalEventUrl(lastSelectedEvent));
  });
}

/* @ngInject */
function BlueprintCurrentModuleNavCtrl($window, $route, $location, $rootScope, $scope, uiService, orgService, userService, deeplinkService, blueprintService, entitlementsService, urlService) {
  var updateNavFn = function updateNavFn() {
    var currentRouteDescriptor = $route.current ? $route.current.$$route : undefined;

    // presence used to determine whether to hide/show the nav branding
    $scope.routePath = currentRouteDescriptor ? currentRouteDescriptor.path : undefined;
    var currentRouteBlueprintMetadata = currentRouteDescriptor ? currentRouteDescriptor.blueprintMetadata : undefined;
    if (!currentRouteBlueprintMetadata) {
      return;
    }
    var module = currentRouteBlueprintMetadata.module,
      moduleKey = currentRouteBlueprintMetadata.moduleKey,
      controller = currentRouteBlueprintMetadata.controller,
      controllerKey = currentRouteBlueprintMetadata.controllerKey;
    $scope.module = module;
    $scope.moduleKey = moduleKey;
    $scope.controller = controller;
    $scope.controllerKey = controllerKey;

    // if the controller defines its own menu item, don't show tabs
    if (controller.bstgMenu) {
      $scope.navItems = [];
    } else {
      var headings = blueprintService.getControllerHeadings(moduleKey);
      $scope.navItems = headings.filter(function (ctrl) {
        return !ctrl.bstgMenu;
      });
    }

    // begin handling fullscreen query param
    var search = $location.search();
    var fullscreenItemTarget = search ? search.fullscreen : undefined;
    if (fullscreenItemTarget) {
      angular.element(document.body).addClass('maximized');
      switch (fullscreenItemTarget) {
        case 'controller':
        case 'true':
          return $scope.controller.fullscreen._active = true;
        case 'module':
          if (!$scope.module.fullscreen) {
            $scope.module.fullscreen = {};
          }
          return $scope.module.fullscreen._active = true;
        default:
          return $location.search('fullscreen', null);
      }
    } else {
      angular.element(document.body).removeClass('maximized');

      // set the query param based on which view is active (if any)
      if ($scope.controller.fullscreen._active) {
        $location.search('fullscreen', 'controller');
      }
      if ($scope.module.fullscreen._active) {
        return $location.search('fullscreen', 'module');
      }
    }
  };
  $rootScope.$watch('event', /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(currentEvent, oldEvent) {
      var orgId, currentUser, org, report, products, seats, seatReport, seatOverage, availableSeats;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(currentEvent && currentEvent.id !== (oldEvent || {}).id)) {
              _context.next = 23;
              break;
            }
            if (!(currentEvent && currentEvent.entitlements_enabled)) {
              _context.next = 23;
              break;
            }
            orgId = currentEvent.ownerId;
            currentUser = userService.getCurrentUser();
            org = findWhere(currentUser.orgs, {
              _id: orgId
            });
            if (!(!org || !org.entitlements_enabled)) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return");
          case 7:
            _context.next = 9;
            return entitlementsService.getEventUsageReport(currentEvent.id);
          case 9:
            report = _context.sent;
            if (!currentEvent.entitlements_v2) {
              _context.next = 21;
              break;
            }
            _context.next = 13;
            return entitlementsService.getPurchaseOrganizationProducts(orgId, 'subscription');
          case 13:
            products = _context.sent;
            // returns products with type 'subscription'
            // there can be only one product as the pools of seats are aggregated
            seats = products[0];
            seatReport = report.find(function (item) {
              return item.type === 'subscription';
            });
            seatOverage = (seatReport || {}).overage || 0;
            availableSeats = seats && seats.usage && seats.usage.available ? seats.usage.available : 0;
            $scope.shouldShowOverUsageNotice = availableSeats - seatOverage < 0;
            _context.next = 22;
            break;
          case 21:
            $scope.shouldShowOverUsageNotice = report.some(function (r) {
              return r.isOverUsage;
            });
          case 22:
            if (userService.matchesRoles([{
              orgRole: 'entitlement_manager',
              orgId: orgId
            }, {
              globalRole: 'superadmin'
            }, {
              isSpotme: true
            }])) {
              $scope.canViewEntitlements = true;
            }
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  $scope.navigateToEventEntitlementsManager = function () {
    var _$rootScope$event = $rootScope.event,
      id = _$rootScope$event.id,
      ownerId = _$rootScope$event.ownerId;
    var orgName = ownerId.replace(orgService.ORG_ID_PREFIX, '');
    var url = urlService.getTopLevelAppInstanceUrl("/org/".concat(orgName, "/entitlements/per-event-entitlements?eid=").concat(id));
    $scope.navigateHard(url);
  };
  updateNavFn();
  $rootScope.$on('$routeChangeSuccess', updateNavFn);
  $scope.shouldHideFullscreenControls = function () {
    // hide if we're using a deeplink in 'controller' fullscreen mode
    if (deeplinkService.isCurrentUrlAnAccreditedDeeplink()) {
      deeplinkService.rememberInAccreditedDeeplinkMode();
      if (deeplinkService.getCurrentBlueprintFullscreenMode() === 'module') {
        return false;
      }
      return true;
    }

    // we hide them in mobile safari's standalone app mode or if controller embeds them
    var currentControllerBlueprint = ((($route.current || {}).$$route || {}).blueprintMetadata || {}).controller;
    if (!currentControllerBlueprint) {
      return true;
    }
    return $window.navigator.standalone || currentControllerBlueprint.fullscreen && currentControllerBlueprint.fullscreen._embedded_controls;
  };
  $scope.toggleFullscreenModeForCurrentNavItem = function (navItemType, $event, forceOpen) {
    if (!navItemType) {
      navItemType = 'controller';
    }
    $event && $event.preventDefault();
    var moduleOrController = navItemType === 'controller' ? $scope.controller : $scope.module;
    if (!moduleOrController.fullscreen) {
      moduleOrController.fullscreen = {};
    }
    if (forceOpen) {
      moduleOrController.fullscreen._active = true;
    }
    var isActive = forceOpen || (moduleOrController.fullscreen._active = !moduleOrController.fullscreen._active);
    angular.element(document.body).toggleClass('maximized', isActive);
    $location.search('fullscreen', isActive ? navItemType : false);
    $rootScope.$applyAsync();
  };
  $scope.exitFullscreenModes = function () {
    if ($scope.module.fullscreen ? $scope.module.fullscreen._active : undefined) {
      $scope.module.fullscreen._active = false;
    }
    if ($scope.controller.fullscreen ? $scope.controller.fullscreen._active : undefined) {
      $scope.controller.fullscreen._active = false;
    }
    angular.element(document.body).removeClass('maximized');
    $location.search('fullscreen', null);

    // Called to change the URL in the browser to reflect
    // the new location value
    $rootScope.$applyAsync();
  };
  $scope.enterBrowserFullscreenMode = function () {
    return $scope.$emit('event:request-browser-full-screen:main-container');
  };
  $scope.logout = userService.logout;
  $scope.shouldShowNavItem = uiService.shouldShowNavItem;

  // Global fullscreen controls
  $rootScope.enterFullscreen = function (fullframe) {
    $scope.toggleFullscreenModeForCurrentNavItem(null, null, true);
    $rootScope.fullframeScreen = fullframe;
    if (fullframe) {
      $scope.enterBrowserFullscreenMode();
    }
  };
  $rootScope.exitFullscreen = function () {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      /* Firefox */
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE/Edge */
      document.msExitFullscreen();
    }
    if (!$rootScope.fullframeScreen) {
      return $scope.$root.exitFullscreenModes();
    }
  };
  $rootScope.exitFullscreenModes = $scope.exitFullscreenModes;
}

/* @ngInject */
function ReorderableModuleListNavCtrl($scope, eventService, localStorageService, metricsService) {
  var intermediateNavDescriptors = $scope.intermediateNavDescriptors = [];
  var getLocalStorageKey = function getLocalStorageKey() {
    var localStorageKey = 'userModuleOrderMap:';
    var eventId = (eventService.getCurrentEvent() || {}).id;
    if (!eventId) {
      return "".concat(localStorageKey, "root");
    }
    return localStorageKey + eventId;
  };
  $scope.toggleModuleReorderMode = function () {
    $scope.inModuleReorderMode = !$scope.inModuleReorderMode;
    if ($scope.inModuleReorderMode) {
      return $scope.revealAllModules = true;
    }
  };
  $scope.saveModuleOrdering = function (reorderedModuleKeys) {
    // tracking
    var hasChanges = !$scope.intermediateNavDescriptors.every(function (navItem, idx) {
      return reorderedModuleKeys[idx] === navItem.moduleKey;
    });
    metricsService.track('nav_module_reorder_save', {
      hasChanges: hasChanges
    });
    // /tracking

    var reorderedNavDescriptors = _.chain($scope.navDescriptors).sortBy(function (navDescriptor) {
      return reorderedModuleKeys.indexOf(navDescriptor.moduleKey);
    }).map(function (navDescriptor, idx) {
      navDescriptor = _.clone(navDescriptor);
      navDescriptor.order = idx;
      return navDescriptor;
    }).value();
    var reorderedNavOrderMappings = _.chain(reorderedNavDescriptors).map(function (navDescriptor) {
      return [navDescriptor.moduleKey, navDescriptor.order];
    }).object().value();
    $scope.intermediateNavDescriptors = reorderedNavDescriptors;
    return localStorageService.set(getLocalStorageKey(), reorderedNavOrderMappings);
  };
  $scope.navigateToModule = function ($clickEvent) {
    if ($scope.inModuleReorderMode) {
      if ($clickEvent) {
        $clickEvent.preventDefault();
      }
      return;
    }
    if (typeof $scope.collapseExtendedModuleDisplay === 'function') {
      $scope.collapseExtendedModuleDisplay();
    }
  };
  return $scope.$watch(function () {
    return JSON.stringify($scope.navDescriptors);
  }, function () {
    var newNavDescriptors = $scope.navDescriptors;
    // mutex to hold on replacing dom element order with that in navDescriptors array

    if (!newNavDescriptors || !newNavDescriptors.length || $scope.lastModuleReorderModeHandled !== $scope.inModuleReorderMode) {
      return;
    }
    var areOrdersSyncedWithDisplay = function areOrdersSyncedWithDisplay(userSavedOrderingsMap) {
      var activeOrderingsMap = _.chain(newNavDescriptors).map(function (navDescriptor) {
        return [navDescriptor.moduleKey, navDescriptor.order || 0];
      }).object().value();
      return angular.equals(activeOrderingsMap, userSavedOrderingsMap);
    };
    var customModuleOrderMap = localStorageService.get(getLocalStorageKey());
    if (customModuleOrderMap && !areOrdersSyncedWithDisplay(customModuleOrderMap)) {
      newNavDescriptors = _.chain(newNavDescriptors).map(function (navDescriptor /* , idx */) {
        var storedOrder = customModuleOrderMap[navDescriptor.moduleKey];
        navDescriptor = _.clone(navDescriptor);
        navDescriptor.order = _.isNumber(storedOrder) ? storedOrder : navDescriptor.order || 0;
        return navDescriptor;
      }).sortBy('order').value();
      return $scope.saveModuleOrdering(_.pluck(newNavDescriptors, 'moduleKey'));
    } else {
      return angular.copy(newNavDescriptors, intermediateNavDescriptors);
    }
  });
}
angular.module('backstage.controllers.main', []).controller('MainEventContextNavCtrl', MainEventContextNavCtrl).controller('BlueprintCurrentModuleNavCtrl', BlueprintCurrentModuleNavCtrl).controller('ReorderableModuleListNavCtrl', ReorderableModuleListNavCtrl);